import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const udpateArtifactForDeal = (
  treeId,
  dealId,
  interactionId,
  payload,
  callback,
) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_ARTIFACT_FOR_DEAL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/discovery-tree/${treeId}/deals/${dealId}/interactions/${interactionId}`,
            payload,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_ARTIFACT_FOR_DEAL_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_ARTIFACT_FOR_DEAL_FAILED',
              payload: `Failed to update activity for deal`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_ARTIFACT_FOR_DEAL_FAILED',
            payload: `Failed to update activity for deal`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_ARTIFACT_FOR_DEAL_FAILED',
        payload: `Failed to update activity for deal`,
      });
    }
  };
};

export default udpateArtifactForDeal;
